// Notification transports shared by web and mobile.
import { jsonOrThrow } from "./api.js";
export async function fetchNotifications(client, includeDismissed = false) {
    const res = await client.api.notifications.$get({
        query: { include_dismissed: includeDismissed ? "true" : "false" },
    });
    return jsonOrThrow(res, "GET /api/notifications");
}
export async function dismissNotification(client, id) {
    const res = await client.api.notifications[":id"].dismiss.$post({ param: { id } });
    await jsonOrThrow(res, "POST /api/notifications/:id/dismiss");
}
export async function dismissAllNotifications(client) {
    const res = await client.api.notifications["dismiss-all"].$post();
    return jsonOrThrow(res, "POST /api/notifications/dismiss-all");
}
//# sourceMappingURL=notifications.js.map